

import * as formAPI from "@/api/forms";
import * as repliesAPI from "@/api/replies";
import {Question} from "@/api/types/Question";
import {Form} from "@/api/types/Form";
import {Answer} from "@/api/types/Answer";
import {Reply} from "@/api/types/Reply";

import TimePickerField from "@/components/form/fields/time_picker/TimePickerField.vue";
import DatePickerField from "@/components/form/fields/date_picker/DatePickerField.vue";
import DropdownField from "@/components/form/fields/dropdown/DropdownField.vue";
import CheckboxGroupField from "@/components/form/fields/checkbox_group/CheckboxGroupField.vue";
import RadioGroupField from "@/components/form/fields/radio_group/RadioGroupField.vue";
import LongAnswerField from "@/components/form/fields/LongAnswerField.vue";
import ShortAnswerField from "@/components/form/fields/ShortAnswerField.vue";
import LinearScaleField from "@/components/form/fields/linear_scale/LinearScaleField.vue";
import DividerField from "@/components/form/fields/divider/DividerField.vue";

import * as replyAPI from "@/api/replies";
import * as groupAPI from "@/api/group";
import {Group} from "@/api/types/Group";
import XmppMessaging from "@/shared/mixins/XmppMessaging";
import mixins from "vue-typed-mixins";
import TenantList from "@/components/form/TenantList.vue";
import {Section} from "@/api/types/Section";
import ConfirmationDialog from "@/components/form/ConfirmationDialog.vue";

const MIXINS = [XmppMessaging];
const Vue = mixins(...MIXINS);

export default Vue.extend({
  name: "FormReply",
  components: {
    ConfirmationDialog,
    TenantList,
    LinearScaleField,
    ShortAnswerField,
    LongAnswerField,
    RadioGroupField,
    CheckboxGroupField,
    DropdownField,
    DatePickerField,
    TimePickerField,
    DividerField
  },
  data() {
    return {
      loading: true,
      submitted: false,
      closedEditReply: false,
      form: {
        title: "",
        description: "",
        photoUrl: "",
        questions: [
          {
            title: "",
            type: "text-field",
            required: false,
            options: [""],
            linearScale: {
              minValue: "0",
              maxValue: "1",
              minLabel: "",
              maxLabel: "",
            },
          },
        ] as Partial<Question>[],
        tenantIds: [] as string[],
      } as Partial<Form>,
      reply: {
        answers: [{value: []}] as Partial<Answer>[],
      } as Partial<Reply>,
      groups: [] as Group[],
      confirmDialog: false as boolean,
      loadingGroups: false as boolean,
      groupDialog: false as boolean,
      selectedGroup: null as number | null,
      submitting: false as boolean,
      editMode: false as boolean,
      formUid: '' as string,
      replyId: '' as string,
      search: '' as string,
      sections: [] as Section[],
      step: 1 as number,
      confirmationTitle: '' as string,
      confirmationDescription: '' as string,
      confirmationActionText: '' as string,
      confirmationType: 'form' as string,
      numberOfStepsAllowedText: 7 as number,
    }
  },
  created() {
    if (this.$route.params.replyId != null) {
      this.editMode = true;
      this.replyId = this.$route.params.replyId;
    }

    if (this.$route.params.id) {
      this.loadForm(this.$route.params.id);
    }
  },
  methods: {
    loadForm(id: string) {
      this.formUid = id;
      // Get form from API
      formAPI.fetchByUid(id).then(completeForm => {
        this.form = completeForm;
        this.reply.answers = [];
        this.sections = [];

        this.form.questions?.forEach((question, index) => {

          if (question.type === 'divider') {
            this.sections.push({index: index, title: question.title || ''});
          }

          question.index = index;
          this.reply.answers?.push({
            value: [],
            type: question.type,
            questionId: question.id,
          });
        });

        if (this.sections.length === 0 || (this.sections.length > 0 && this.sections[0].index !== 0)) {
          this.sections.unshift({
            index: 0,
            title: this.form.title || '',
          })
        }

        if (this.editMode) {
          this.loadAnswer(this.replyId);
        }
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        throw err;
      })
    },
    getImageUrl(imageUrl: string) {
      if (imageUrl.split(':')[0] === 'blob') {
        return imageUrl;
      }
      const api_url = process.env.VUE_APP_API_URL;
      return `${api_url}/files/${imageUrl}`;
    },
    loadAnswer(id: string) {
      repliesAPI.fetch(+id).then((completeReplies: any) => {
        completeReplies.answers.forEach((a: any, index: number) => {
          let qId = a.questionId;
          let indexQ = this.form.questions?.findIndex((q: any) => q.id === qId);
          if (this.reply && this.reply.answers && indexQ != null && indexQ >= 0) {
            this.reply.answers[indexQ].value = a.value;
            this.reply.answers[indexQ].id = a.id;
          }
        })
        this.loading = false;
      }).catch(err => {
        this.loading = false;
        throw err;
      })
    },
    getColFlex(): number {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 12;
        case "sm":
          return 6;
        case "md":
          return 4;
        case "lg":
          return 3;
        case "xl":
          return 2;
        default:
          return 12;
      }
    },
    cleanForm(options: Record<string, unknown>): void {
      this.reply.answers?.map(elem => {
        const question = this.form.questions?.find(q => q.id === elem.questionId);
        if(((this.editMode && question?.editable) || !this.editMode) && (question?.required && options.mandatory || !question?.required)) {
          elem.value = [];
        }
        return elem;
      });
      this.step = 1;
      this.sections.forEach((section, index) => {
        const formRef: any = this.$refs[`form-${index}`];

        if (formRef && formRef.length > 0) {
          formRef[0].resetValidation();
        }
      });
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    cleanSection(options: Record<string, unknown>) {

      let start = this.sections[this.step - 1].index;
      let end = this.step === this.sections.length ? (this.reply.answers?.length ?? 1 - 1) : this.sections[this.step].index;

      this.reply.answers?.slice(start, end).map(elem => {
        const question = this.form.questions?.find(q => q.id === elem.questionId);
        if(((this.editMode && question?.editable) || !this.editMode) && (question?.required && options.mandatory || !question?.required)) {
          elem.value = [];
        }
        return elem;
      });

      const formRef: any = this.$refs[`form-${this.step}`];

      if (formRef && formRef.length > 0) {
        formRef[0].resetValidation();
      }

      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });

    },
    getTotalScore() {
      if (this.reply && this.reply.answers && this.form && this.form.score) {
        let totalScore = 0;
        for (let i = 0; i < this.reply.answers.length; i++) {
          let iAnswer = this.reply.answers[i];
          if (!iAnswer.value || !iAnswer.value.length) {
            continue;
          }

          let iQuestion = this.form.questions?.find(quest => iAnswer.questionId === quest.id);
          if (!iQuestion) {
            continue;
          }
          if (['radio-group', 'checkbox', 'select'].includes(iAnswer.type ?? '')) {
            if (iQuestion.options && iQuestion.scoreList) {
              let scoreList = iQuestion.scoreList;
              let options = iQuestion.options;
              if (scoreList && options) {
                if (iAnswer.type === 'checkbox') {
                  for (let j = 0; j < iAnswer.value.length; j++) {
                    let selectedAnswer = iAnswer.value[j];
                    let index = options.indexOf(selectedAnswer);
                    if (index >= 0) {
                      totalScore += +scoreList[index] ?? 0
                    }
                  }
                } else {
                  let index = options.indexOf(iAnswer.value[0]);
                  if (index >= 0) {
                    totalScore += +scoreList[index] ?? 0
                  }
                }
              }
            }
          }
        }
        return totalScore;
      }

      return 0;
    },
    questionGetProps(type: string, question: any) {
      switch (type) {
        case 'text-field':
          return {
            label: this.$t('forms.form.preview.yourAnswer'),
            required: question.required,
            validation: question.validation,
            extraValidations: question.extraValidations,
            disabled: this.editMode ? !question.editable : false,
          };
        case 'text-area':
          return {
            label: this.$t('forms.form.preview.yourAnswer'),
            required: question.required,
            validation: question.validation,
            extraValidations: question.extraValidations,
            disabled: this.editMode ? !question.editable : false,
          };
        case 'radio-group':
          return {
            options: question.options,
            required: question.required,
            validation: question.validation,
            extraValidations: question.extraValidations,
            score: this.form.score,
            scores: question.scoreList,
            disabled: this.editMode ? !question.editable : false,
          };
        case 'checkbox':
          return {
            options: question.options,
            required: question.required,
            validation: question.validation,
            extraValidations: question.extraValidations,
            score: this.form.score,
            scores: question.scoreList,
            disabled: this.editMode ? !question.editable : false,
          };
        case 'date-input':
          return {
            label: this.$t('forms.form.preview.pickDate'),
            required: question.required,
            validation: question.validation,
            extraValidations: question.extraValidations,
            disabled: this.editMode ? !question.editable : false,
          };
        case 'select':
          return {
            label: this.$t('forms.form.preview.chooseOption'),
            required: question.required,
            options: question.options,
            validation: question.validation,
            extraValidations: question.extraValidations,
            score: this.form.score,
            scores: question.scoreList,
            disabled: this.editMode ? !question.editable : false,
          };
        case 'linear-scale':
          return {
            required: question.required,
            min: question.linearScale.minValue,
            max: question.linearScale.maxValue,
            fromLabel: question.linearScale.minLabel,
            toLabel: question.linearScale.maxLabel,
            validation: question.validation,
            extraValidations: question.extraValidations,
            disabled: this.editMode ? !question.editable : false,
          };
        case 'divider':
          return {};
        default:
          return {
            required: question.required,
            label: this.$t('forms.form.preview.yourAnswer'),
            validation: question.validation,
            extraValidations: question.extraValidations,
            disabled: this.editMode ? !question.editable : false,
          };
      }
    },
    openConfirmSubmit() {
      this.confirmDialog = true;
    },
    sendXmppMessage(id: number) {
      if (this.selectedGroup != null) {
        let message = `${this.form.title} ${this.editMode ? `(${this.$t("forms.form.edited")})` : ''}\n\n`
        this.form.questions?.forEach((elem) => {
          if (elem && elem.index != null) {

            const title = elem.title;
            const answer = this.reply.answers ? this.reply.answers[elem.index].value?.join(", ") || '' : '';
            if (elem.type !== 'divider') {
              message += `${title}${elem.type !== 'divider' ? ':' : ''} ${answer}\n`;
            } else {
              message += `\n ----- ${title} ----- \n\n`;
            }
          }
        });

        if (this.form.score) {
          message += `\n\n${this.$t("forms.form.preview.totalScore")}: ${this.getTotalScore()}\n`;
          if (this.form.scoreRules && this.form.scoreRules.length > 0) {
            message += `${this.getRuleTitle()}\n`
          }
        }

        message += `\n\n${this.$t("forms.form.reply.editUrl")}: ${window.location.origin}/form-reply/${this.formUid}/${id}\n`;
        // Fixed for Join production
        const jid = this.filteredGroups()[this.selectedGroup].chat.jid;
        const groupName = this.filteredGroups()[this.selectedGroup].name;
        this.xmppMessagingSendMessage({message: message, type: 'text', toJid: jid, groupName: groupName});
      }
    },
    submitForm(): void {
      this.reply.formId = this.form.id;
      this.submitting = true;
      replyAPI.create(this.reply).then((resp: any) => {
        this.sendXmppMessage(resp.id);
        this.cleanForm({ mandatory: true });
        this.submitted = true;
        this.submitting = false;
        this.groupDialog = false;
        this.confirmDialog = false;
      }).catch(() => {
        this.submitting = false;
      });

    },
    editReply(saveAndSend: boolean, form: string) {
      const formRef: any = this.$refs[form];

      if (formRef && formRef.length > 0 && formRef[0].validate()) {
        let answersWithoutDivider = this.reply.answers?.filter((a: any) => a.type !== 'divider');
        this.submitting = true;
        replyAPI.patch(+this.replyId, {
          answers: answersWithoutDivider,
          tenantId: this.reply.tenantId,
          formId: this.form.id
        }).then(() => {
          if (saveAndSend) {
            this.sendXmppMessage(+this.replyId);
          }
          this.cleanForm({ mandatory: true });
          this.submitted = true;
          this.submitting = false;
          this.groupDialog = false;
          this.confirmDialog = false;
        }).catch(err => {
          this.submitting = false;
          console.log(err);
        });
      } else {
        this.$nextTick(() => {
          const el = document.querySelector(".v-messages.error--text");
          el!.scrollIntoView({block: 'center', behavior: 'smooth'});
          this.$forceUpdate()
        });
      }
    },
    openGroupsDialog(form: string) {
      const formRef: any = this.$refs[form];

      if (formRef && formRef.length > 0 && formRef[0].validate()) {
        this.groupDialog = true;
        this.getGroups();
      } else {
        this.$nextTick(() => {
          const el = document.querySelector(".v-messages.error--text");
          el!.scrollIntoView({block: 'center', behavior: 'smooth'});
          this.$forceUpdate()
        });
      }
    },
    getGroups(): void {
      this.loadingGroups = true;
      groupAPI.list().then(result => {
        // this.groups = [];
        this.groups = result;
        this.loadingGroups = false
      }).catch(err => {
        this.loadingGroups = false
        throw err
      })
    },
    anotherResponse() {
      this.reply.answers = [];
      this.form.questions?.forEach((question) =>
          this.reply.answers?.push({
            value: [],
            type: question.type,
            questionId: question.id
          }));
      this.editMode = false;
      this.submitted = false;
      this.closedEditReply = false;
    },
    setTenant(tenantId: string) {
      this.reply.tenantId = tenantId;
    },
    getRuleTitle() {
      const score = this.getTotalScore();
      if (score == null) {
        return "";
      }

      for (let rule of this.form.scoreRules ?? []) {
        if (rule.operator != null && this.evaluateOperator(rule.operator, score, rule.value ?? 0)) {
          return rule.title!.replace(/\n/g, "<br />");
        }
      }

      return "";
    },
    evaluateOperator(operator: string, score: number, value: number) {
      switch (operator) {
        case "<=":
          return score <= value;
        case "<":
          return score < value;
        case "==":
          return score == value;
        case ">=":
          return score >= value;
        case ">":
          return score > value;
        default:
          return false;
      }

    },
    filteredGroups() {
      if (this.search != null && this.search != '') {
        return this.groups.filter(g => g.name.toLowerCase().includes(this.search.toLowerCase()));
      }
      return this.groups;
    },
    nextSection(form: string) {
      const formRef: any = this.$refs[form];

      if (formRef && formRef.length > 0 && formRef[0].validate()) {
        if (this.step < this.sections.length) {
          this.step += 1;
          window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        }
      } else {
        this.$nextTick(() => {
          const el = document.querySelector(".v-messages.error--text");
          el!.scrollIntoView({block: 'center', behavior: 'smooth'});
          this.$forceUpdate()
        });
      }
    },
    openConfirmationDialog(title: string, description: string, action: string, type: string) {
      this.confirmationTitle = title;
      this.confirmationDescription = description;
      this.confirmationActionText = action;
      this.confirmationType = type;

      const confirmationDialog: any = this.$refs.confirmationRef;
      if(confirmationDialog) {
        confirmationDialog.openDialog();
      }

    },
    executeClean(options: Record<string, unknown>) {
      if (this.confirmationType === "section") {
        this.cleanSection(options);
      } else if (this.confirmationType === "form") {
        this.cleanForm(options);
      }
    },
    closeEditForm() {
      this.closedEditReply = true;
      this.submitted = false;
      this.submitting = false;
      this.groupDialog = false;
      this.confirmDialog = false;
    },
    backToHome() {
      this.$router.push(`/forms`).catch((err) => {
        console.log(err);
      });
    }
  },
  computed: {
    questionTypeComponent: {
      set() {
        return [];
      },
      get() {
        return {
          'text-field': 'short-answer-field',
          'text-area': 'long-answer-field',
          'radio-group': 'radio-group-field',
          'checkbox': 'checkbox-group-field',
          'date-input': 'date-picker-field',
          'time-input': 'time-picker-field',
          'select': 'dropdown-field',
          'linear-scale': 'linear-scale-field',
          'divider': 'divider-field',
        }
      }
    },
    formTenants(): string[] {
      return this.form.tenantIds || [];
    },
  }
});
